"use strict";var ddWithoutApi=require("./entry/union"),apiObj_1=require("./api/apiObj"),dd=Object.assign(ddWithoutApi,apiObj_1.apiObj);module.exports=dd;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/index.js
// module id = 275
// module chunks = 106